<div class="floori-tutorial-toast-card">
    <!-- Top glowing accent bar -->
    <div class="toast-accent-bar"></div>

    <div class="toast-card-top-row">
        <div class="toast-icon-badge">
            <div class="icon-badge-glow"></div>
            <floori-icon name="fl_general_info_circle"></floori-icon>
        </div>

        <div class="toast-body-text">
            <div class="toast-text-content">
                <span class="toast-title">Notice</span>
                @for (line of data.text; track trackBy($index, line)) {
                    <p class="toast-desc">
                        {{ line | flTranslate }}
                    </p>
                }
            </div>
        </div>

        <button type="button" class="toast-close-btn" floori-dialog-close aria-label="Close message">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    </div>

    <div class="toast-card-bottom-row">
        <div class="toast-actions">
            <button
                type="button"
                class="toast-action-btn primary"
                floori-dialog-close>
                <span class="btn-glow"></span>
                <span class="btn-text">{{ data.buttonText || "Close" | flTranslate }}</span>
            </button>
        </div>
    </div>
</div>

